import React from 'react'
import {createSearchParams, Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolId, getSchoolYear} from "../../../../../utils/authority";
import vi from "date-fns/locale/vi";
import Utils from "../../../../../utils/utils";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AutoSearchPeople from "../../../../../components/auto-search-people";
import FilesApi from "../../../../../services/resource/files-api";
import CLBController from "../../../../../services/system/clb/clb-controller";
import PublicSecureAuthorization
    from "../../../../../services/system/secure-authorization/secure-authorization-controller";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import Dropzone from "react-dropzone";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()}/>;
}
function uploadAdapter(loader) {
    return {
        upload: () => {
            return new Promise((resolve, reject) => {
                FilesApi.uploadFileCkeditor( loader, res => {
                    if (res.success) {
                        resolve({
                            default: res.data.url
                        });
                    }else {
                        reject(res.error);
                    }
                })
            })
        }
    }
}
function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return uploadAdapter(loader);
    };
}

class DetailClassCLBManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imgFile: "",
            startDay: new Date(),
            endDay: new Date(),
            state: 'WAIT_PUBLISH',
            price: 0,
            surcharge: 0,
            totalSlot: 0,
            principalId: '',
            principalName: '',
            principalUsername: '',

            dateActive: null,
            gradeStr: "",
            title: "",
            groupId: 0,
            yearId: parseInt(getSchoolYear()),
            recipientId: 0,
            content: "",
            listGroupUser: [],
            classRoomId: 0,
            listClassRoom: [],
            files: [],

            pageNumber: 0,
            pageSize: 10,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "class",
                    name: "Lớp",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],
            headerCancel: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "class",
                    name: "Lớp",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "phuHuynh",
                    name: "Tên phụ huynh",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "payment",
                    name: "Lý do hủy",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],
        };
    }

    componentWillMount() {
        const [searchparams] = this.props.params;
        let clbId = searchparams.get("id");
        this.getDetailCLB(clbId)
        this.getAllClass()
        this.getListGroupUser()
    }
    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderStatus() {
        let listStatus = [
            {
                "id": "WAIT_PUBLISH",
                "name": "Chờ phát hành"
            },
            {
                "id": "PUBLISH",
                "name": "Đã phát hành"
            },
            {
                "id": "LOCKED",
                "name": "Đã khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onEdit = () => {
        let price = parseFloat(this.state.price.toString().replaceAll(",", ""))
        let surcharge = parseFloat(this.state.surcharge.toString().replaceAll(",", ""))

        let {name} = this.state;
        if (name == "" || name.length < 5){
            toast.error("Tên CLB phải lớn hơn 5 ký tự");
        }else if(this.state.content == ""){
            toast.error("Vui lòng nhập nội dung CLB");
        }else if(this.state.totalSlot < 1){
            toast.error("Số học sinh phải lớn hơn 0");
        }else {
            let payload = {
                "id": this.state.id,
                "name": this.state.name,
                "headTeacherId": parseInt(this.state.principalId),
                "state": this.state.state,
                "numberSessions": parseInt(this.state.numberSessions),
                "price": price,
                "surcharge": surcharge,
                "totalSlot": this.state.totalSlot,
                "content": this.state.content,
                "schoolDay": this.state.schoolDay,
                "schoolPlace": this.state.schoolPlace,
                "serviceImage": this.state.serviceImage,
                "startDay": moment(this.state.startDay).format("yyyy-MM-DD"),
                "endDay": moment(this.state.endDay).format("yyyy-MM-DD"),
                "schoolId": parseInt(getSchoolId()),
                "yearId": parseInt(getSchoolYear()),
            }
            CLBController.edit(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-lop-clb');
                    toast.success("Cập nhật CLB thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }

    getDetailCLB(clbId) {
        CLBController.detail(clbId, res => {
            if (res.success){
                    this.setState({
                        "content": res.data.content,
                        "endDay": res.data.endDay,
                        "id": res.data.id,
                        "name": res.data.name,
                        "numberSessions": res.data.numberSessions,
                        "price": res.data.price,
                        "schoolDay": res.data.schoolDay,
                        "schoolPlace": res.data.schoolPlace,
                        "startDay": res.data.startDay,
                        "state": res.data.state,
                        "surcharge": res.data.surcharge,
                        "totalSlot": res.data.totalSlot,
                        "serviceImage": res.data.serviceImage,
                        "files": [ res.data.serviceImage],
                        "principalName": res.data.headTeacherRes?.fullName,
                        "principalId": res.data.headTeacherRes?.id,
                    }, ()=>{
                        this.showImage();
                    })
            }else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    showImage(){
        if (this.state.serviceImage.length > 0){
            FilesApi.showFile(this.state.serviceImage, res=>{
                this.setState({
                    imgFile: res
                })
            })
        }
    }
    onUpImage = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    serviceImage: res.data.url,
                }, () => {
                    toast.success('Tải ảnh thành công!')
                    this.showImage()
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    getHp1Buoi() {
        let total = parseInt(this.state.numberSessions)
        if (total< 1)
            total = 1
        let price = parseFloat(this.state.price.toString().replaceAll(",", ""))
        let hp = Utils.formatMoney(Math.round(price/total))
        return hp + " đ"
    }

    render() {
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name}-{file.size} bytes
            </li>
        ));
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="class-clb" parentClass="clb-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Chi tiết đăng ký lớp CLB"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>Chi tiết lớp CLB</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thông tin CLB
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên CLB</label>
                                                <input
                                                    placeholder="Nhập tên CLB"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mt-2">
                                                <label className="label-item col-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        })
                                                    }}
                                                >
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số buổi học</label>
                                                <input
                                                    placeholder="Nhập số buổi học"
                                                    maxLength={255} type="number"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.numberSessions}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            numberSessions: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nhập học phí 1 khóa</label>
                                                <input
                                                    placeholder="Nhập học phí 1 khóa"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.price)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            price: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Phí phụ thu</label>
                                                <input
                                                    placeholder="Phụ thu phí"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={Utils.formatMoney(this.state.surcharge)}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            surcharge: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Học phí 1 buổi</label>
                                                <label className="col-4 label-item pl-0">{this.getHp1Buoi()}</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số học sinh 1 lớp</label>
                                                <input
                                                    placeholder="Số học sinh 1 lớp"
                                                    type="number"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.totalSlot}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            totalSlot: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2"></div>
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 label-item pl-0">Icon hiển thị ở ứng dụng</label>
                                                <Dropzone accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, video/mp4, audio/mpeg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/vnd.ms-excel
, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-7z-compressed"
                                                          onDrop={acceptedFiles => {
                                                              this.setState({files: acceptedFiles}, () =>{
                                                                  this.onUpImage()
                                                              })
                                                          }}
                                                          multiple={false}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section className="container-upload col-md-10">
                                                            <div {...getRootProps({className: 'dropzone'})}>
                                                                <img width="200px" key={this.state.imgFile} src={this.state.imgFile} />
                                                                <input {...getInputProps()} />
                                                                {files.length > 0 ? <div className="align-center">
                                                                    <ul>{files}</ul>
                                                                </div> : <p>Chọn tập tin để upload 1</p>}
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Nội dung dạy CLB</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                {/*https://www.techgalery.com/2021/05/how-to-use-react-ckeditor-upload-file.html*/}
                                                <CKEditor
                                                    config={{
                                                        extraPlugins: [uploadPlugin]
                                                    }}
                                                    editor={ ClassicEditor }
                                                    data={this.state.content}
                                                    onReady={ editor => {
                                                        // You can store the "editor" and use when it is needed.
                                                        // console.log( 'Editor is ready to use!', editor );
                                                    } }
                                                    onChange={ ( event, editor ) => {
                                                        const data = editor.getData();
                                                        this.saveContent(data)
                                                        // console.log( { event, editor, data } );
                                                    } }
                                                />
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Thông tin lóp CLB
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Thầy giáo phụ trách</label>
                                                <AutoSearchPeople
                                                    principalId={this.state.principalId}
                                                    principalName={this.state.principalName}
                                                    principalUsername={this.state.principalUsername}
                                                    onUpdateData={(principalId, principalUsername, principalName) => this.setState({principalId: principalId, principalName: principalName, principalUsername: principalUsername})}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2"></div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày/Giờ học trong tuần</label>
                                                <input
                                                    placeholder="VD: Thứ 2(18h00), Thứ 3(18h30), Thứ 5(18h00)"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.schoolDay}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            schoolDay: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Địa điểm học</label>
                                                <input
                                                    placeholder="VD: Lớp 1A"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.schoolPlace}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            schoolPlace: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày bắt đầu học</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.startDay === '' ? null : new Date(this.state.startDay)}
                                                    minDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            try {
                                                                this.setState({
                                                                    startDay: date,
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày kết thúc</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.endDay === '' ? null : new Date(this.state.endDay)}
                                                    minDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            try {
                                                                this.setState({
                                                                    endDay: date,
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == ""}
                                            onClick={()=> {
                                                this.onEdit()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4  border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-lop-clb"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(DetailClassCLBManagement)